export const ResetIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.67736 20.5675C2.53135 18.0214 0.75797 12.7586 2.71672 8.14409C4.87466 3.06029 10.7452 0.688411 15.829 2.84636C20.9128 5.00431 23.2847 10.8749 21.1268 15.9587C20.2836 17.9452 18.8735 19.5176 17.165 20.5675"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 16V20.4C17 20.7314 17.2686 21 17.6 21H22"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
